import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col } from 'react-bootstrap';
import { Input, TextArea } from 'components';
import { lettersAndLatinCharactersMask } from 'util/masks';

export default function StepThree({ handleSubmit }) {
  return (
    <Form id="address" onSubmit={handleSubmit}>
      <Row>
        <Col xs={12} className="p-0">
          <Input
            name="phone"
            label="Teléfono*"
            inputMode="numeric"
            pattern="\d*"
            maxLength={10}
          />
          <TextArea
            name="betweenStreets"
            label="Entre calles*"
            maxLength={100}
            mask={lettersAndLatinCharactersMask}
          />
          <TextArea
            name="additionalReferences"
            label="Referencias adicionales*"
            maxLength={100}
            mask={lettersAndLatinCharactersMask}
          />
        </Col>
      </Row>
    </Form>
  );
}

StepThree.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
}
